import { useEffect, useState } from 'react'

import type { Primitive } from './types'

export const safeGet = (obj: any, pathOrFn: string | ((r: any) => any)) => {
  if (typeof pathOrFn === 'function') return pathOrFn(obj)
  const path = pathOrFn.split('.')
  let cur = obj
  for (const p of path) cur = cur?.[p]
  return cur
}

export const toStr = (v: Primitive | null | undefined) =>
  v === null || v === undefined ? '' : String(v)

export const fromStr = (raw: string, like: Primitive): Primitive =>
  typeof like === 'number' ? Number(raw) : raw

export function useDebouncedValue<T>(value: T, delay: number) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(handle)
  }, [value, delay])

  return debounced
}
